module.exports = __webpack_public_path__ + "img/sand-rock-big-04.34cd5320.png";